export default "__VITE_ASSET__DPfNje4g__"